// extracted by mini-css-extract-plugin
module.exports = {"content":"dp-Zk5lbupg","mainContent":"dp-LoobRQSE","title":"dp-cAryNBT1","inputContainer":"dp-G8wbOcXq","searchBtn":"dp-PeT1RsN5"};